import React from "react";

import "./styles.css";
/**
 * @function FeesPaymentsView
 * @return {React.Component}
 * @exported true
 * @description The main component for FeesPaymentsView
 */

export default function FeesPaymentsView(props) {
  return (
    <>Fees Payments View</>
  );
}